import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDragDropRight = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 129,
	height: 100,
	viewBox: "0 0 129 100",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemBody",
			d: "M102.106 21.8398H47.231C45.7274 21.8398 44.5085 23.0587 44.5085 24.5623V29.6868C44.5085 31.1904 45.7274 32.4092 47.231 32.4092H102.106C103.61 32.4092 104.829 31.1904 104.829 29.6868V24.5623C104.829 23.0587 103.61 21.8398 102.106 21.8398Z",
			fill: "#373D62"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemZone",
			d: "M44.6687 24.5623C44.6687 23.1472 45.8158 22 47.2309 22H50.1135V32.2491H47.2309C45.8158 32.2491 44.6687 31.1019 44.6687 29.6868V24.5623Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragDots",
			d: "M47.3373 28.4057C47.3373 28.6406 47.1451 28.8327 46.9103 28.8327C46.6754 28.8327 46.4832 28.6406 46.4832 28.4057C46.4832 28.1708 46.6754 27.9786 46.9103 27.9786C47.1451 27.9786 47.3373 28.1708 47.3373 28.4057ZM46.9103 26.6975C46.6754 26.6975 46.4832 26.8897 46.4832 27.1246C46.4832 27.3594 46.6754 27.5516 46.9103 27.5516C47.1451 27.5516 47.3373 27.3594 47.3373 27.1246C47.3373 26.8897 47.1451 26.6975 46.9103 26.6975ZM46.9103 25.4164C46.6754 25.4164 46.4832 25.6085 46.4832 25.8434C46.4832 26.0783 46.6754 26.2705 46.9103 26.2705C47.1451 26.2705 47.3373 26.0783 47.3373 25.8434C47.3373 25.6085 47.1451 25.4164 46.9103 25.4164ZM48.1914 26.2705C48.4263 26.2705 48.6184 26.0783 48.6184 25.8434C48.6184 25.6085 48.4263 25.4164 48.1914 25.4164C47.9565 25.4164 47.7643 25.6085 47.7643 25.8434C47.7643 26.0783 47.9565 26.2705 48.1914 26.2705ZM48.1914 26.6975C47.9565 26.6975 47.7643 26.8897 47.7643 27.1246C47.7643 27.3594 47.9565 27.5516 48.1914 27.5516C48.4263 27.5516 48.6184 27.3594 48.6184 27.1246C48.6184 26.8897 48.4263 26.6975 48.1914 26.6975ZM48.1914 27.9786C47.9565 27.9786 47.7643 28.1708 47.7643 28.4057C47.7643 28.6406 47.9565 28.8327 48.1914 28.8327C48.4263 28.8327 48.6184 28.6406 48.6184 28.4057C48.6184 28.1708 48.4263 27.9786 48.1914 27.9786Z",
			fill: "#6C75AC"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragTextZone",
			d: "M64.6978 23.9218H53.9576C53.2501 23.9218 52.6765 24.4953 52.6765 25.2029V29.0463C52.6765 29.7538 53.2501 30.3274 53.9576 30.3274H64.6978C65.4053 30.3274 65.9789 29.7538 65.9789 29.0463V25.2029C65.9789 24.4953 65.4053 23.9218 64.6978 23.9218Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask0_10852_900882",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 90,
			y: 24,
			width: 10,
			height: 6,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M96.9829 24.5623H92.8833C91.4682 24.5623 90.321 25.7094 90.321 27.1245C90.321 28.5396 91.4682 29.6868 92.8833 29.6868H96.9829C98.3981 29.6868 99.5452 28.5396 99.5452 27.1245C99.5452 25.7094 98.3981 24.5623 96.9829 24.5623Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask0_10852_900882)",
			children: [/* @__PURE__ */ _jsx("path", {
				className: "switch",
				d: "M96.9829 24.5623H92.8833C91.4682 24.5623 90.321 25.7094 90.321 27.1245C90.321 28.5396 91.4682 29.6868 92.8833 29.6868H96.9829C98.3981 29.6868 99.5452 28.5396 99.5452 27.1245C99.5452 25.7094 98.3981 24.5623 96.9829 24.5623Z",
				fill: "#6674CC"
			}), /* @__PURE__ */ _jsx("g", {
				filter: "url(#filter0_dd_10852_900882)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "switchDot",
					d: "M96.9822 29.1743C98.1143 29.1743 99.032 28.2566 99.032 27.1245C99.032 25.9924 98.1143 25.0747 96.9822 25.0747C95.8501 25.0747 94.9324 25.9924 94.9324 27.1245C94.9324 28.2566 95.8501 29.1743 96.9822 29.1743Z",
					fill: "#CED1E3"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemBorder",
			d: "M102.106 21.8398H47.231C45.7274 21.8398 44.5085 23.0587 44.5085 24.5623V29.6868C44.5085 31.1904 45.7274 32.4092 47.231 32.4092H102.106C103.61 32.4092 104.829 31.1904 104.829 29.6868V24.5623C104.829 23.0587 103.61 21.8398 102.106 21.8398Z",
			stroke: "#404772",
			strokeWidth: .320284
		}),
		/* @__PURE__ */ _jsxs("g", {
			opacity: .5,
			children: [
				/* @__PURE__ */ _jsx("path", {
					className: "dragItemBody",
					d: "M58.7723 38.8398H3.89697C2.39342 38.8398 1.17456 40.0587 1.17456 41.5623V46.6868C1.17456 48.1904 2.39342 49.4092 3.89697 49.4092H58.7723C60.2758 49.4092 61.4947 48.1904 61.4947 46.6868V41.5623C61.4947 40.0587 60.2758 38.8398 58.7723 38.8398Z",
					fill: "#373D62"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "dragItemZone",
					d: "M1.33472 41.5623C1.33472 40.1472 2.48189 39 3.89699 39H6.77954V49.2491H3.89699C2.48188 49.2491 1.33472 48.1019 1.33472 46.6868V41.5623Z",
					fill: "#404772"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "dragDots",
					d: "M4.00326 45.4057C4.00326 45.6406 3.81109 45.8327 3.57622 45.8327C3.34134 45.8327 3.14917 45.6406 3.14917 45.4057C3.14917 45.1708 3.34134 44.9787 3.57622 44.9787C3.81109 44.9787 4.00326 45.1708 4.00326 45.4057ZM3.57622 43.6975C3.34134 43.6975 3.14917 43.8897 3.14917 44.1246C3.14917 44.3594 3.34134 44.5516 3.57622 44.5516C3.81109 44.5516 4.00326 44.3594 4.00326 44.1246C4.00326 43.8897 3.81109 43.6975 3.57622 43.6975ZM3.57622 42.4164C3.34134 42.4164 3.14917 42.6086 3.14917 42.8434C3.14917 43.0783 3.34134 43.2705 3.57622 43.2705C3.81109 43.2705 4.00326 43.0783 4.00326 42.8434C4.00326 42.6086 3.81109 42.4164 3.57622 42.4164ZM4.85735 43.2705C5.09223 43.2705 5.2844 43.0783 5.2844 42.8434C5.2844 42.6086 5.09223 42.4164 4.85735 42.4164C4.62248 42.4164 4.43031 42.6086 4.43031 42.8434C4.43031 43.0783 4.62248 43.2705 4.85735 43.2705ZM4.85735 43.6975C4.62248 43.6975 4.43031 43.8897 4.43031 44.1246C4.43031 44.3594 4.62248 44.5516 4.85735 44.5516C5.09223 44.5516 5.2844 44.3594 5.2844 44.1246C5.2844 43.8897 5.09223 43.6975 4.85735 43.6975ZM4.85735 44.9787C4.62248 44.9787 4.43031 45.1708 4.43031 45.4057C4.43031 45.6406 4.62248 45.8327 4.85735 45.8327C5.09223 45.8327 5.2844 45.6406 5.2844 45.4057C5.2844 45.1708 5.09223 44.9787 4.85735 44.9787Z",
					fill: "#6C75AC"
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "dragTextZone",
					d: "M21.3638 40.9216H10.6237C9.91611 40.9216 9.34253 41.4952 9.34253 42.2028V46.0462C9.34253 46.7537 9.91611 47.3273 10.6237 47.3273H21.3638C22.0713 47.3273 22.6449 46.7537 22.6449 46.0462V42.2028C22.6449 41.4952 22.0713 40.9216 21.3638 40.9216Z",
					fill: "#404772"
				}),
				/* @__PURE__ */ _jsx("mask", {
					id: "mask1_10852_900882",
					style: { maskType: "luminance" },
					maskUnits: "userSpaceOnUse",
					x: 46,
					y: 41,
					width: 11,
					height: 6,
					children: /* @__PURE__ */ _jsx("path", {
						d: "M53.649 41.5623H49.5493C48.1342 41.5623 46.9871 42.7094 46.9871 44.1245C46.9871 45.5396 48.1342 46.6868 49.5493 46.6868H53.649C55.0641 46.6868 56.2112 45.5396 56.2112 44.1245C56.2112 42.7094 55.0641 41.5623 53.649 41.5623Z",
						fill: "white"
					})
				}),
				/* @__PURE__ */ _jsxs("g", {
					mask: "url(#mask1_10852_900882)",
					children: [/* @__PURE__ */ _jsx("path", {
						className: "switch",
						d: "M53.649 41.5623H49.5493C48.1342 41.5623 46.9871 42.7094 46.9871 44.1245C46.9871 45.5396 48.1342 46.6868 49.5493 46.6868H53.649C55.0641 46.6868 56.2112 45.5396 56.2112 44.1245C56.2112 42.7094 55.0641 41.5623 53.649 41.5623Z",
						fill: "#6674CC"
					}), /* @__PURE__ */ _jsx("g", {
						filter: "url(#filter1_dd_10852_900882)",
						children: /* @__PURE__ */ _jsx("path", {
							className: "switchDot",
							d: "M53.6482 46.1743C54.7803 46.1743 55.698 45.2566 55.698 44.1245C55.698 42.9924 54.7803 42.0747 53.6482 42.0747C52.5161 42.0747 51.5984 42.9924 51.5984 44.1245C51.5984 45.2566 52.5161 46.1743 53.6482 46.1743Z",
							fill: "#CED1E3"
						})
					})]
				}),
				/* @__PURE__ */ _jsx("path", {
					className: "dragItemBorder",
					d: "M58.7723 38.8398H3.89697C2.39342 38.8398 1.17456 40.0587 1.17456 41.5623V46.6868C1.17456 48.1904 2.39342 49.4092 3.89697 49.4092H58.7723C60.2758 49.4092 61.4947 48.1904 61.4947 46.6868V41.5623C61.4947 40.0587 60.2758 38.8398 58.7723 38.8398Z",
					stroke: "#404772",
					strokeWidth: .320284
				})
			]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemBody",
			d: "M58.7723 63.8398H3.89697C2.39342 63.8398 1.17456 65.0587 1.17456 66.5623V71.6868C1.17456 73.1904 2.39342 74.4092 3.89697 74.4092H58.7723C60.2758 74.4092 61.4947 73.1904 61.4947 71.6868V66.5623C61.4947 65.0587 60.2758 63.8398 58.7723 63.8398Z",
			fill: "#373D62"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemZone",
			d: "M1.33472 66.5623C1.33472 65.1471 2.48189 64 3.89699 64H6.77954V74.2491H3.89699C2.48188 74.2491 1.33472 73.1019 1.33472 71.6868V66.5623Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragDots",
			d: "M4.00326 70.4057C4.00326 70.6406 3.81109 70.8327 3.57622 70.8327C3.34134 70.8327 3.14917 70.6406 3.14917 70.4057C3.14917 70.1708 3.34134 69.9786 3.57622 69.9786C3.81109 69.9786 4.00326 70.1708 4.00326 70.4057ZM3.57622 68.6975C3.34134 68.6975 3.14917 68.8897 3.14917 69.1245C3.14917 69.3594 3.34134 69.5516 3.57622 69.5516C3.81109 69.5516 4.00326 69.3594 4.00326 69.1245C4.00326 68.8897 3.81109 68.6975 3.57622 68.6975ZM3.57622 67.4164C3.34134 67.4164 3.14917 67.6085 3.14917 67.8434C3.14917 68.0783 3.34134 68.2705 3.57622 68.2705C3.81109 68.2705 4.00326 68.0783 4.00326 67.8434C4.00326 67.6085 3.81109 67.4164 3.57622 67.4164ZM4.85735 68.2705C5.09223 68.2705 5.2844 68.0783 5.2844 67.8434C5.2844 67.6085 5.09223 67.4164 4.85735 67.4164C4.62248 67.4164 4.43031 67.6085 4.43031 67.8434C4.43031 68.0783 4.62248 68.2705 4.85735 68.2705ZM4.85735 68.6975C4.62248 68.6975 4.43031 68.8897 4.43031 69.1245C4.43031 69.3594 4.62248 69.5516 4.85735 69.5516C5.09223 69.5516 5.2844 69.3594 5.2844 69.1245C5.2844 68.8897 5.09223 68.6975 4.85735 68.6975ZM4.85735 69.9786C4.62248 69.9786 4.43031 70.1708 4.43031 70.4057C4.43031 70.6406 4.62248 70.8327 4.85735 70.8327C5.09223 70.8327 5.2844 70.6406 5.2844 70.4057C5.2844 70.1708 5.09223 69.9786 4.85735 69.9786Z",
			fill: "#6C75AC"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragTextZone",
			d: "M21.3638 65.9218H10.6237C9.91611 65.9218 9.34253 66.4953 9.34253 67.2029V71.0463C9.34253 71.7538 9.91611 72.3274 10.6237 72.3274H21.3638C22.0713 72.3274 22.6449 71.7538 22.6449 71.0463V67.2029C22.6449 66.4953 22.0713 65.9218 21.3638 65.9218Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask2_10852_900882",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 46,
			y: 66,
			width: 11,
			height: 6,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M53.649 66.5623H49.5493C48.1342 66.5623 46.9871 67.7094 46.9871 69.1245C46.9871 70.5396 48.1342 71.6868 49.5493 71.6868H53.649C55.0641 71.6868 56.2112 70.5396 56.2112 69.1245C56.2112 67.7094 55.0641 66.5623 53.649 66.5623Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask2_10852_900882)",
			children: [/* @__PURE__ */ _jsx("path", {
				className: "switch",
				d: "M53.649 66.5623H49.5493C48.1342 66.5623 46.9871 67.7094 46.9871 69.1245C46.9871 70.5396 48.1342 71.6868 49.5493 71.6868H53.649C55.0641 71.6868 56.2112 70.5396 56.2112 69.1245C56.2112 67.7094 55.0641 66.5623 53.649 66.5623Z",
				fill: "#6674CC"
			}), /* @__PURE__ */ _jsx("g", {
				filter: "url(#filter2_dd_10852_900882)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "switchDot",
					d: "M53.6482 71.1743C54.7803 71.1743 55.698 70.2566 55.698 69.1245C55.698 67.9924 54.7803 67.0747 53.6482 67.0747C52.5161 67.0747 51.5984 67.9924 51.5984 69.1245C51.5984 70.2566 52.5161 71.1743 53.6482 71.1743Z",
					fill: "#CED1E3"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemBorder",
			d: "M58.7723 63.8398H3.89697C2.39342 63.8398 1.17456 65.0587 1.17456 66.5623V71.6868C1.17456 73.1904 2.39342 74.4092 3.89697 74.4092H58.7723C60.2758 74.4092 61.4947 73.1904 61.4947 71.6868V66.5623C61.4947 65.0587 60.2758 63.8398 58.7723 63.8398Z",
			stroke: "#404772",
			strokeWidth: .320284
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemBody",
			d: "M125.106 38.8398H70.231C68.7274 38.8398 67.5085 40.0587 67.5085 41.5623V46.6868C67.5085 48.1904 68.7274 49.4092 70.231 49.4092H125.106C126.61 49.4092 127.829 48.1904 127.829 46.6868V41.5623C127.829 40.0587 126.61 38.8398 125.106 38.8398Z",
			fill: "#373D62"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemZone",
			d: "M67.6687 41.5623C67.6687 40.1472 68.8158 39 70.2309 39H73.1135V49.2491H70.2309C68.8158 49.2491 67.6687 48.1019 67.6687 46.6868V41.5623Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragDots",
			d: "M70.3373 45.4057C70.3373 45.6406 70.1451 45.8327 69.9103 45.8327C69.6754 45.8327 69.4832 45.6406 69.4832 45.4057C69.4832 45.1708 69.6754 44.9787 69.9103 44.9787C70.1451 44.9787 70.3373 45.1708 70.3373 45.4057ZM69.9103 43.6975C69.6754 43.6975 69.4832 43.8897 69.4832 44.1246C69.4832 44.3594 69.6754 44.5516 69.9103 44.5516C70.1451 44.5516 70.3373 44.3594 70.3373 44.1246C70.3373 43.8897 70.1451 43.6975 69.9103 43.6975ZM69.9103 42.4164C69.6754 42.4164 69.4832 42.6086 69.4832 42.8434C69.4832 43.0783 69.6754 43.2705 69.9103 43.2705C70.1451 43.2705 70.3373 43.0783 70.3373 42.8434C70.3373 42.6086 70.1451 42.4164 69.9103 42.4164ZM71.1914 43.2705C71.4263 43.2705 71.6184 43.0783 71.6184 42.8434C71.6184 42.6086 71.4263 42.4164 71.1914 42.4164C70.9565 42.4164 70.7643 42.6086 70.7643 42.8434C70.7643 43.0783 70.9565 43.2705 71.1914 43.2705ZM71.1914 43.6975C70.9565 43.6975 70.7643 43.8897 70.7643 44.1246C70.7643 44.3594 70.9565 44.5516 71.1914 44.5516C71.4263 44.5516 71.6184 44.3594 71.6184 44.1246C71.6184 43.8897 71.4263 43.6975 71.1914 43.6975ZM71.1914 44.9787C70.9565 44.9787 70.7643 45.1708 70.7643 45.4057C70.7643 45.6406 70.9565 45.8327 71.1914 45.8327C71.4263 45.8327 71.6184 45.6406 71.6184 45.4057C71.6184 45.1708 71.4263 44.9787 71.1914 44.9787Z",
			fill: "#6C75AC"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragTextZone",
			d: "M87.6978 40.9218H76.9576C76.2501 40.9218 75.6765 41.4953 75.6765 42.2029V46.0463C75.6765 46.7538 76.2501 47.3274 76.9576 47.3274H87.6978C88.4053 47.3274 88.9789 46.7538 88.9789 46.0463V42.2029C88.9789 41.4953 88.4053 40.9218 87.6978 40.9218Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask3_10852_900882",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 113,
			y: 41,
			width: 10,
			height: 6,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M119.983 41.5623H115.883C114.468 41.5623 113.321 42.7094 113.321 44.1245C113.321 45.5396 114.468 46.6868 115.883 46.6868H119.983C121.398 46.6868 122.545 45.5396 122.545 44.1245C122.545 42.7094 121.398 41.5623 119.983 41.5623Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask3_10852_900882)",
			children: [/* @__PURE__ */ _jsx("path", {
				className: "switch",
				d: "M119.983 41.5623H115.883C114.468 41.5623 113.321 42.7094 113.321 44.1245C113.321 45.5396 114.468 46.6868 115.883 46.6868H119.983C121.398 46.6868 122.545 45.5396 122.545 44.1245C122.545 42.7094 121.398 41.5623 119.983 41.5623Z",
				fill: "#6674CC"
			}), /* @__PURE__ */ _jsx("g", {
				filter: "url(#filter3_dd_10852_900882)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "switchDot",
					d: "M119.982 46.1743C121.114 46.1743 122.032 45.2566 122.032 44.1245C122.032 42.9924 121.114 42.0747 119.982 42.0747C118.85 42.0747 117.932 42.9924 117.932 44.1245C117.932 45.2566 118.85 46.1743 119.982 46.1743Z",
					fill: "#CED1E3"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemBorder",
			d: "M125.106 38.8398H70.231C68.7274 38.8398 67.5085 40.0587 67.5085 41.5623V46.6868C67.5085 48.1904 68.7274 49.4092 70.231 49.4092H125.106C126.61 49.4092 127.829 48.1904 127.829 46.6868V41.5623C127.829 40.0587 126.61 38.8398 125.106 38.8398Z",
			stroke: "#404772",
			strokeWidth: .320284
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemBody",
			d: "M58.7723 51.3309H3.89697C2.39342 51.3309 1.17456 52.5498 1.17456 54.0533V59.1779C1.17456 60.6815 2.39342 61.9003 3.89697 61.9003H58.7723C60.2758 61.9003 61.4947 60.6815 61.4947 59.1779V54.0533C61.4947 52.5498 60.2758 51.3309 58.7723 51.3309Z",
			fill: "#373D62"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemZone",
			d: "M1.33472 54.0534C1.33472 52.6383 2.48189 51.4911 3.89699 51.4911H6.77954V61.7402H3.89699C2.48188 61.7402 1.33472 60.593 1.33472 59.1779V54.0534Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask4_10852_900882",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 1,
			y: 54,
			width: 6,
			height: 6,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M6.77957 54.0533H1.65503V59.1779H6.77957V54.0533Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask4_10852_900882)",
			children: /* @__PURE__ */ _jsx("path", {
				className: "dragDots",
				d: "M4.00326 57.8968C4.00326 58.1317 3.81109 58.3238 3.57622 58.3238C3.34134 58.3238 3.14917 58.1317 3.14917 57.8968C3.14917 57.6619 3.34134 57.4697 3.57622 57.4697C3.81109 57.4697 4.00326 57.6619 4.00326 57.8968ZM3.57622 56.1886C3.34134 56.1886 3.14917 56.3808 3.14917 56.6156C3.14917 56.8505 3.34134 57.0427 3.57622 57.0427C3.81109 57.0427 4.00326 56.8505 4.00326 56.6156C4.00326 56.3808 3.81109 56.1886 3.57622 56.1886ZM3.57622 54.9075C3.34134 54.9075 3.14917 55.0996 3.14917 55.3345C3.14917 55.5694 3.34134 55.7616 3.57622 55.7616C3.81109 55.7616 4.00326 55.5694 4.00326 55.3345C4.00326 55.0996 3.81109 54.9075 3.57622 54.9075ZM4.85735 55.7616C5.09223 55.7616 5.2844 55.5694 5.2844 55.3345C5.2844 55.0996 5.09223 54.9075 4.85735 54.9075C4.62248 54.9075 4.43031 55.0996 4.43031 55.3345C4.43031 55.5694 4.62248 55.7616 4.85735 55.7616ZM4.85735 56.1886C4.62248 56.1886 4.43031 56.3808 4.43031 56.6156C4.43031 56.8505 4.62248 57.0427 4.85735 57.0427C5.09223 57.0427 5.2844 56.8505 5.2844 56.6156C5.2844 56.3808 5.09223 56.1886 4.85735 56.1886ZM4.85735 57.4697C4.62248 57.4697 4.43031 57.6619 4.43031 57.8968C4.43031 58.1317 4.62248 58.3238 4.85735 58.3238C5.09223 58.3238 5.2844 58.1317 5.2844 57.8968C5.2844 57.6619 5.09223 57.4697 4.85735 57.4697Z",
				fill: "#6C75AC"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragTextZone",
			d: "M21.3638 53.4128H10.6237C9.91611 53.4128 9.34253 53.9864 9.34253 54.694V58.5374C9.34253 59.2449 9.91611 59.8185 10.6237 59.8185H21.3638C22.0713 59.8185 22.6449 59.2449 22.6449 58.5374V54.694C22.6449 53.9864 22.0713 53.4128 21.3638 53.4128Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask5_10852_900882",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 46,
			y: 54,
			width: 11,
			height: 6,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M53.649 54.0533H49.5493C48.1342 54.0533 46.9871 55.2005 46.9871 56.6156C46.9871 58.0307 48.1342 59.1779 49.5493 59.1779H53.649C55.0641 59.1779 56.2112 58.0307 56.2112 56.6156C56.2112 55.2005 55.0641 54.0533 53.649 54.0533Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask5_10852_900882)",
			children: [/* @__PURE__ */ _jsx("path", {
				className: "switch",
				d: "M53.649 54.0533H49.5493C48.1342 54.0533 46.9871 55.2005 46.9871 56.6156C46.9871 58.0307 48.1342 59.1779 49.5493 59.1779H53.649C55.0641 59.1779 56.2112 58.0307 56.2112 56.6156C56.2112 55.2005 55.0641 54.0533 53.649 54.0533Z",
				fill: "#6674CC"
			}), /* @__PURE__ */ _jsx("g", {
				filter: "url(#filter4_dd_10852_900882)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "switchDot",
					d: "M53.6482 58.6653C54.7803 58.6653 55.698 57.7476 55.698 56.6155C55.698 55.4834 54.7803 54.5657 53.6482 54.5657C52.5161 54.5657 51.5984 55.4834 51.5984 56.6155C51.5984 57.7476 52.5161 58.6653 53.6482 58.6653Z",
					fill: "#CED1E3"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemBorder",
			d: "M58.7723 51.3309H3.89697C2.39342 51.3309 1.17456 52.5498 1.17456 54.0533V59.1779C1.17456 60.6815 2.39342 61.9003 3.89697 61.9003H58.7723C60.2758 61.9003 61.4947 60.6815 61.4947 59.1779V54.0533C61.4947 52.5498 60.2758 51.3309 58.7723 51.3309Z",
			stroke: "#404772",
			strokeWidth: .320284
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemBody",
			d: "M58.7723 76.3309H3.89697C2.39342 76.3309 1.17456 77.5498 1.17456 79.0533V84.1779C1.17456 85.6815 2.39342 86.9003 3.89697 86.9003H58.7723C60.2758 86.9003 61.4947 85.6815 61.4947 84.1779V79.0533C61.4947 77.5498 60.2758 76.3309 58.7723 76.3309Z",
			fill: "#373D62"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemZone",
			d: "M1.33472 79.0533C1.33472 77.6382 2.48189 76.4911 3.89699 76.4911H6.77954V86.7401H3.89699C2.48188 86.7401 1.33472 85.593 1.33472 84.1779V79.0533Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask6_10852_900882",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 1,
			y: 79,
			width: 6,
			height: 6,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M6.77957 79.0533H1.65503V84.1779H6.77957V79.0533Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsx("g", {
			mask: "url(#mask6_10852_900882)",
			children: /* @__PURE__ */ _jsx("path", {
				className: "dragDots",
				d: "M4.00326 82.8968C4.00326 83.1316 3.81109 83.3238 3.57622 83.3238C3.34134 83.3238 3.14917 83.1316 3.14917 82.8968C3.14917 82.6619 3.34134 82.4697 3.57622 82.4697C3.81109 82.4697 4.00326 82.6619 4.00326 82.8968ZM3.57622 81.1886C3.34134 81.1886 3.14917 81.3808 3.14917 81.6156C3.14917 81.8505 3.34134 82.0427 3.57622 82.0427C3.81109 82.0427 4.00326 81.8505 4.00326 81.6156C4.00326 81.3808 3.81109 81.1886 3.57622 81.1886ZM3.57622 79.9075C3.34134 79.9075 3.14917 80.0996 3.14917 80.3345C3.14917 80.5694 3.34134 80.7615 3.57622 80.7615C3.81109 80.7615 4.00326 80.5694 4.00326 80.3345C4.00326 80.0996 3.81109 79.9075 3.57622 79.9075ZM4.85735 80.7615C5.09223 80.7615 5.2844 80.5694 5.2844 80.3345C5.2844 80.0996 5.09223 79.9075 4.85735 79.9075C4.62248 79.9075 4.43031 80.0996 4.43031 80.3345C4.43031 80.5694 4.62248 80.7615 4.85735 80.7615ZM4.85735 81.1886C4.62248 81.1886 4.43031 81.3808 4.43031 81.6156C4.43031 81.8505 4.62248 82.0427 4.85735 82.0427C5.09223 82.0427 5.2844 81.8505 5.2844 81.6156C5.2844 81.3808 5.09223 81.1886 4.85735 81.1886ZM4.85735 82.4697C4.62248 82.4697 4.43031 82.6619 4.43031 82.8968C4.43031 83.1316 4.62248 83.3238 4.85735 83.3238C5.09223 83.3238 5.2844 83.1316 5.2844 82.8968C5.2844 82.6619 5.09223 82.4697 4.85735 82.4697Z",
				fill: "#6C75AC"
			})
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragTextZone",
			d: "M21.3638 78.4128H10.6237C9.91611 78.4128 9.34253 78.9864 9.34253 79.694V83.5374C9.34253 84.2449 9.91611 84.8185 10.6237 84.8185H21.3638C22.0713 84.8185 22.6449 84.2449 22.6449 83.5374V79.694C22.6449 78.9864 22.0713 78.4128 21.3638 78.4128Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask7_10852_900882",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 46,
			y: 79,
			width: 11,
			height: 6,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M53.649 79.0533H49.5493C48.1342 79.0533 46.9871 80.2005 46.9871 81.6156C46.9871 83.0307 48.1342 84.1779 49.5493 84.1779H53.649C55.0641 84.1779 56.2112 83.0307 56.2112 81.6156C56.2112 80.2005 55.0641 79.0533 53.649 79.0533Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask7_10852_900882)",
			children: [/* @__PURE__ */ _jsx("path", {
				className: "switch",
				d: "M53.649 79.0533H49.5493C48.1342 79.0533 46.9871 80.2005 46.9871 81.6156C46.9871 83.0307 48.1342 84.1779 49.5493 84.1779H53.649C55.0641 84.1779 56.2112 83.0307 56.2112 81.6156C56.2112 80.2005 55.0641 79.0533 53.649 79.0533Z",
				fill: "#6674CC"
			}), /* @__PURE__ */ _jsx("g", {
				filter: "url(#filter5_dd_10852_900882)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "switchDot",
					d: "M53.6482 83.6654C54.7803 83.6654 55.698 82.7477 55.698 81.6156C55.698 80.4835 54.7803 79.5658 53.6482 79.5658C52.5161 79.5658 51.5984 80.4835 51.5984 81.6156C51.5984 82.7477 52.5161 83.6654 53.6482 83.6654Z",
					fill: "#CED1E3"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemBorder",
			d: "M58.7723 76.3309H3.89697C2.39342 76.3309 1.17456 77.5498 1.17456 79.0533V84.1779C1.17456 85.6815 2.39342 86.9003 3.89697 86.9003H58.7723C60.2758 86.9003 61.4947 85.6815 61.4947 84.1779V79.0533C61.4947 77.5498 60.2758 76.3309 58.7723 76.3309Z",
			stroke: "#404772",
			strokeWidth: .320284
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemBody",
			d: "M58.7723 88.8398H3.89697C2.39342 88.8398 1.17456 90.0587 1.17456 91.5623V96.6868C1.17456 98.1904 2.39342 99.4092 3.89697 99.4092H58.7723C60.2758 99.4092 61.4947 98.1904 61.4947 96.6868V91.5623C61.4947 90.0587 60.2758 88.8398 58.7723 88.8398Z",
			fill: "#373D62"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemZone",
			d: "M1.33472 91.5623C1.33472 90.1471 2.48189 89 3.89699 89H6.77954V99.249H3.89699C2.48188 99.249 1.33472 98.102 1.33472 96.687V91.5623Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragDots",
			d: "M4.00326 95.406C4.00326 95.641 3.81109 95.833 3.57622 95.833C3.34134 95.833 3.14917 95.641 3.14917 95.406C3.14917 95.171 3.34134 94.979 3.57622 94.979C3.81109 94.979 4.00326 95.171 4.00326 95.406ZM3.57622 93.698C3.34134 93.698 3.14917 93.89 3.14917 94.125C3.14917 94.359 3.34134 94.552 3.57622 94.552C3.81109 94.552 4.00326 94.359 4.00326 94.125C4.00326 93.89 3.81109 93.698 3.57622 93.698ZM3.57622 92.416C3.34134 92.416 3.14917 92.609 3.14917 92.843C3.14917 93.078 3.34134 93.27 3.57622 93.27C3.81109 93.27 4.00326 93.078 4.00326 92.843C4.00326 92.609 3.81109 92.416 3.57622 92.416ZM4.85735 93.27C5.09223 93.27 5.2844 93.078 5.2844 92.843C5.2844 92.609 5.09223 92.416 4.85735 92.416C4.62248 92.416 4.43031 92.609 4.43031 92.843C4.43031 93.078 4.62248 93.27 4.85735 93.27ZM4.85735 93.698C4.62248 93.698 4.43031 93.89 4.43031 94.125C4.43031 94.359 4.62248 94.552 4.85735 94.552C5.09223 94.552 5.2844 94.359 5.2844 94.125C5.2844 93.89 5.09223 93.698 4.85735 93.698ZM4.85735 94.979C4.62248 94.979 4.43031 95.171 4.43031 95.406C4.43031 95.641 4.62248 95.833 4.85735 95.833C5.09223 95.833 5.2844 95.641 5.2844 95.406C5.2844 95.171 5.09223 94.979 4.85735 94.979Z",
			fill: "#6C75AC"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragTextZone",
			d: "M21.3638 90.9218H10.6237C9.91611 90.9218 9.34253 91.4953 9.34253 92.2029V96.0463C9.34253 96.7538 9.91611 97.3274 10.6237 97.3274H21.3638C22.0713 97.3274 22.6449 96.7538 22.6449 96.0463V92.2029C22.6449 91.4953 22.0713 90.9218 21.3638 90.9218Z",
			fill: "#404772"
		}),
		/* @__PURE__ */ _jsx("mask", {
			id: "mask8_10852_900882",
			style: { maskType: "luminance" },
			maskUnits: "userSpaceOnUse",
			x: 46,
			y: 91,
			width: 11,
			height: 6,
			children: /* @__PURE__ */ _jsx("path", {
				d: "M53.649 91.5623H49.5493C48.1342 91.5623 46.9871 92.7094 46.9871 94.1245C46.9871 95.5396 48.1342 96.6868 49.5493 96.6868H53.649C55.0641 96.6868 56.2112 95.5396 56.2112 94.1245C56.2112 92.7094 55.0641 91.5623 53.649 91.5623Z",
				fill: "white"
			})
		}),
		/* @__PURE__ */ _jsxs("g", {
			mask: "url(#mask8_10852_900882)",
			children: [/* @__PURE__ */ _jsx("path", {
				className: "switch",
				d: "M53.649 91.5623H49.5493C48.1342 91.5623 46.9871 92.7094 46.9871 94.1245C46.9871 95.5396 48.1342 96.6868 49.5493 96.6868H53.649C55.0641 96.6868 56.2112 95.5396 56.2112 94.1245C56.2112 92.7094 55.0641 91.5623 53.649 91.5623Z",
				fill: "#6674CC"
			}), /* @__PURE__ */ _jsx("g", {
				filter: "url(#filter6_dd_10852_900882)",
				children: /* @__PURE__ */ _jsx("path", {
					className: "switchDot",
					d: "M53.6482 96.1748C54.7803 96.1748 55.698 95.2571 55.698 94.125C55.698 92.9929 54.7803 92.0752 53.6482 92.0752C52.5161 92.0752 51.5984 92.9929 51.5984 94.125C51.5984 95.2571 52.5161 96.1748 53.6482 96.1748Z",
					fill: "#CED1E3"
				})
			})]
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "dragItemBorder",
			d: "M58.7723 88.8398H3.89697C2.39342 88.8398 1.17456 90.0587 1.17456 91.5623V96.6868C1.17456 98.1904 2.39342 99.4092 3.89697 99.4092H58.7723C60.2758 99.4092 61.4947 98.1904 61.4947 96.6868V91.5623C61.4947 90.0587 60.2758 88.8398 58.7723 88.8398Z",
			stroke: "#404772",
			strokeWidth: .320284
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M85.7986 18.7186L81.6212 14.7333L87.1613 13.1082L85.7986 18.7186ZM84.3123 16.2244C84.0403 15.6954 83.7187 15.15 83.3438 14.5972L84.1714 14.0359C84.5686 14.6216 84.911 15.2018 85.2016 15.7671L84.3123 16.2244ZM82.1972 13.0911C81.8034 12.627 81.3706 12.1636 80.8968 11.7063L81.5912 10.9868C82.089 11.4672 82.5445 11.9547 82.9597 12.4441L82.1972 13.0911ZM79.4663 10.4499C78.9856 10.0653 78.4723 9.68905 77.9251 9.32442L78.4795 8.49222C79.0509 8.87292 79.5877 9.2664 80.091 9.66911L79.4663 10.4499ZM76.2941 8.33208C75.7539 8.03243 75.1861 7.74439 74.5898 7.47038L75.0074 6.56173C75.6264 6.8462 76.2167 7.14563 76.7792 7.4576L76.2941 8.33208ZM72.8175 6.73137C72.2375 6.5129 71.6342 6.30735 71.0068 6.11644L71.2979 5.15975C71.9457 5.35688 72.5695 5.56938 73.17 5.79556L72.8175 6.73137ZM69.152 5.6132C68.5438 5.4674 67.9156 5.33484 67.2666 5.2168L67.4456 4.23294C68.1124 4.35424 68.7588 4.49059 69.3851 4.64076L69.152 5.6132ZM65.3693 4.92187C64.7484 4.8412 64.1103 4.77332 63.4547 4.71916L63.5371 3.72256C64.2079 3.77798 64.8615 3.8475 65.4981 3.9302L65.3693 4.92187ZM61.5296 4.60239C60.9011 4.57765 60.2577 4.56505 59.5992 4.56531L59.5988 3.56531C60.2703 3.56505 60.927 3.57789 61.5689 3.60316L61.5296 4.60239ZM57.6674 4.60193C57.037 4.62529 56.3937 4.66002 55.7372 4.70665L55.6663 3.70916C56.3339 3.66174 56.9885 3.6264 57.6304 3.60262L57.6674 4.60193ZM53.8103 4.87433C53.4889 4.90733 53.1644 4.94309 52.837 4.98168L52.72 3.98855C53.0523 3.94939 53.3817 3.91308 53.7082 3.87956L53.8103 4.87433ZM52.837 4.98168C52.4919 5.02234 52.151 5.06587 51.8143 5.11218L51.678 4.12151C52.0212 4.07431 52.3685 4.02996 52.72 3.98855L52.837 4.98168ZM49.8028 5.43021C49.1196 5.55279 48.4549 5.68739 47.8084 5.8333L47.5883 4.85784C48.2495 4.7086 48.9287 4.57107 49.6262 4.44593L49.8028 5.43021ZM45.8372 6.3279C45.1693 6.513 44.5227 6.71081 43.8967 6.92039L43.5792 5.97211C44.2222 5.75686 44.8856 5.55393 45.5701 5.36423L45.8372 6.3279ZM41.996 7.61682C41.3522 7.8741 40.7328 8.14451 40.1367 8.42681L39.7087 7.52305C40.3237 7.23176 40.9622 6.95308 41.6249 6.68823L41.996 7.61682ZM38.335 9.35445C37.7329 9.69077 37.1581 10.0399 36.6095 10.4002L36.0605 9.56435C36.6293 9.19081 37.2246 8.82929 37.8473 8.48143L38.335 9.35445ZM34.9636 11.5726C34.4189 11.9932 33.9045 12.4254 33.4189 12.8669L32.7462 12.1271C33.2515 11.6675 33.7865 11.2181 34.3524 10.7811L34.9636 11.5726ZM31.9848 14.2847C31.5178 14.7871 31.0835 15.2981 30.6801 15.8149L29.8918 15.1997C30.3127 14.6604 30.7656 14.1275 31.2524 13.6038L31.9848 14.2847ZM29.5118 17.4558C29.1384 18.0325 28.7999 18.6129 28.4938 19.193L27.6093 18.7264C27.929 18.1205 28.2825 17.5145 28.6724 16.9123L29.5118 17.4558ZM27.6355 21.0132C27.3697 21.6498 27.1406 22.2813 26.945 22.9028L25.9911 22.6027C26.1956 21.9529 26.435 21.2929 26.7128 20.6279L27.6355 21.0132ZM26.4312 24.8462C26.2846 25.5286 26.1779 26.1904 26.1063 26.8238L25.1126 26.7113C25.188 26.0452 25.3 25.3509 25.4535 24.6362L26.4312 24.8462ZM25.9902 28.8255C25.9904 29.1704 26.0017 29.5008 26.023 29.815L25.0253 29.8827C25.0024 29.5453 24.9904 29.1924 24.9902 28.826L25.9902 28.8255Z",
			fill: "#5362C6"
		}),
		/* @__PURE__ */ _jsxs("defs", { children: [
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter0_dd_10852_900882",
				x: 91.9324,
				y: 23.0747,
				width: 10.0996,
				height: 10.0996,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10852_900882"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_10852_900882",
						result: "effect2_dropShadow_10852_900882"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_10852_900882",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter1_dd_10852_900882",
				x: 48.5984,
				y: 40.0747,
				width: 10.0996,
				height: 10.0996,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10852_900882"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_10852_900882",
						result: "effect2_dropShadow_10852_900882"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_10852_900882",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter2_dd_10852_900882",
				x: 48.5984,
				y: 65.0747,
				width: 10.0996,
				height: 10.0996,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10852_900882"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_10852_900882",
						result: "effect2_dropShadow_10852_900882"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_10852_900882",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter3_dd_10852_900882",
				x: 114.932,
				y: 40.0747,
				width: 10.0996,
				height: 10.0996,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10852_900882"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_10852_900882",
						result: "effect2_dropShadow_10852_900882"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_10852_900882",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter4_dd_10852_900882",
				x: 48.5984,
				y: 52.5657,
				width: 10.0996,
				height: 10.0996,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10852_900882"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_10852_900882",
						result: "effect2_dropShadow_10852_900882"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_10852_900882",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter5_dd_10852_900882",
				x: 48.5984,
				y: 77.5658,
				width: 10.0996,
				height: 10.0996,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10852_900882"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_10852_900882",
						result: "effect2_dropShadow_10852_900882"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_10852_900882",
						result: "shape"
					})
				]
			}),
			/* @__PURE__ */ _jsxs("filter", {
				id: "filter6_dd_10852_900882",
				x: 48.5984,
				y: 90.0752,
				width: 10.0996,
				height: 10.0996,
				filterUnits: "userSpaceOnUse",
				colorInterpolationFilters: "sRGB",
				children: [
					/* @__PURE__ */ _jsx("feFlood", {
						floodOpacity: 0,
						result: "BackgroundImageFix"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.06 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "BackgroundImageFix",
						result: "effect1_dropShadow_10852_900882"
					}),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						in: "SourceAlpha",
						type: "matrix",
						values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
						result: "hardAlpha"
					}),
					/* @__PURE__ */ _jsx("feOffset", { dy: 1 }),
					/* @__PURE__ */ _jsx("feGaussianBlur", { stdDeviation: 1.5 }),
					/* @__PURE__ */ _jsx("feColorMatrix", {
						type: "matrix",
						values: "0 0 0 0 0.0627451 0 0 0 0 0.0941176 0 0 0 0 0.156863 0 0 0 0.1 0"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in2: "effect1_dropShadow_10852_900882",
						result: "effect2_dropShadow_10852_900882"
					}),
					/* @__PURE__ */ _jsx("feBlend", {
						mode: "normal",
						in: "SourceGraphic",
						in2: "effect2_dropShadow_10852_900882",
						result: "shape"
					})
				]
			})
		] })
	]
});
export default SvgDragDropRight;
